import {
  DefaultEntityFilters,
  EntityAutocompletePicker,
  EntityFilter,
} from '@backstage/plugin-catalog-react';
import { ANNOTATION_SLACK_NAME } from '@appfolio/backstage-plugin-catalog-common';

const FACET = `metadata.annotations.${ANNOTATION_SLACK_NAME}`;

class EntityUserSlackNameFilter implements EntityFilter {
  public constructor(readonly values: string[]) {}

  public getCatalogFilters(): Record<string, string | string[]> {
    return { [FACET]: this.values };
  }

  public toQueryValue(): string[] {
    return this.values;
  }
}

export const EntityUserSlackNamePicker = () => (
  <EntityAutocompletePicker<
    DefaultEntityFilters & {
      userSlackName: EntityUserSlackNameFilter;
    }
  >
    label="Slack Username"
    name="userSlackName"
    path={FACET}
    Filter={EntityUserSlackNameFilter}
  />
);
